export function formatNumber(value) {
    // TODO: Internationalization format should change according to user's language selection
    return new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(value);
}
